export default "__VITE_ASSET__BB$_qKjr__"